/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Title from 'material/copy/title/title';
import ImageUpload from 'material/imageupload/imageupload_container';
import ColorPicker from 'material/embeds/colorpicker/colorpicker';
import Tip from 'material/message/tip/tip';
import Icon from 'material/graphic/icon/icon';
import Toggle from 'material/toggle/toggle';
import Note from 'material/copy/note/note';
import Field from 'material/form/field/field_container';
import ControllerContainer from 'pages/dashboard/embeds/management/customize/controllercontainer/controllercontainer';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/embedproperties/embedproperties_styles';



/* ========== ~~~~~~~~~~ PROPERTY EDITOR : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class EmbedProperties extends Component {
	constructor(props) {
		super(props);
		this.state = { partnerurl: true };
		this.setPartnerLogoSrc = this.setPartnerLogoSrc.bind(this);
		this.validateURL = this.validateURL.bind(this);
		this.setBrandColor = this.setBrandColor.bind(this);
		this.processInput = this.processInput.bind(this);
		this.setPartnerLogoPreview = this.setPartnerLogoPreview.bind(this);
		this.handleLogoToggle = this.handleLogoToggle.bind(this);
	}
	componentDidMount() {
		if (this.props.partnerLogo.url !== null) {
			this.validateURL(this.props.partnerLogo.url);
		}
	}
	processInput(e) {
		this.validateURL(e.target.value);
		if (this.isValid(e.target.value)) {
			this.props.setPartnerLogoUrl(e.target.value)
		}
	}
	validateURL(url) {
		this.setState({ partnerurl: this.isValid(url) });
	}
	isValid(data) {
		return /^(|https?:\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&amp;:/~\+#]*[\w\-\@?^=%&amp;/~\+#])?)$/.test(data);
	}
	setPartnerLogoPreview(imageFile) {
		this.props.setPartnerLogoSrc(imageFile);
	}
	setPartnerLogoSrc(imageFile) {
		this.props.setPartnerLogoSrc(URL.createObjectURL(imageFile));
		this.props.updatePartnerLogo(this.props.accountUUID, imageFile);
	}
	setBrandColor(color) {
		this.props.setEmbedProperty('brandColor', color);
	}
	handleLogoToggle() {
		this.props.toggleShowPartnerLogo(!this.props.showPartnerLogo);
	}
	showPlacement = () => this.props.location === 'in-content' ? 'incontent' : 'rail';
	render() {
		return (
			<div className={`embedproperties ${this.props.classes.embedproperties} ${this.showPlacement()}`}>
				<ControllerContainer>
					<Title>
						<h4>Embed Branding</h4>
					</Title>
					<Note>
						<p><span>Embed branding is applied </span>across all screens.</p>
					</Note>
					<div className={`property partnerlogo`}>
						<div className={`proptitle`}>
							<div className={`titleToggle`}>
								<h5>Logo</h5>
								<Toggle handleClick={this.handleLogoToggle} value={null} on={this.props.showPartnerLogo ? 'on' : 'off'} type={'switch'} variant={'secondary'} />
							</div>
						</div>
						<div className={`propdetails ${!this.props.showPartnerLogo ? `noPartnerLogo` : null}`}>
							<div className={`propdetail image`}>
								<ImageUpload previewImage={this.setPartnerLogoPreview} processImage={this.setPartnerLogoSrc} logo={true} src={this.props.partnerLogo.src} imageSize={{ width: '200px', height: 'auto' }} cropSize={{ width: 275, height: 96 }} />
							</div>
						</div>
						<div className={`proptitle`}>
							<div className={`titleToggle`}>
								<h5>Click-through URL</h5>
							</div>
						</div>
						<div className={`propdetails ${!this.props.showPartnerLogo ? `noPartnerLogo` : null}`}>
							<div className={`propdetail link`}>
								<Field type={`url`} name={`partnerurl`} valid={!!this.state.partnerurl} placeholder={this.props.partnerLogo.url === null ? `ex http://www.xyz.com` : ``} handleChange={this.processInput} defaultValue={this.props.partnerLogo.url === null ? `` : this.props.partnerLogo.url}  icon={<Icon name={`link`} />}/>
							</div>
						</div>
					</div>
					<div className={`property brandcolor`}>
						<div className={`proptitle`}>
							<h5>Brand Color <Tip space={`left`} content={`Buttons, progress bars, result bars, and other visual elements will utilize this color to give your embed a more branded appearance.`} /></h5>
						</div>
						<div className={`propdetails`}>
							<div className={`propdetail color`}>
								<ColorPicker color={this.props.brandColor} processColorUpdate={this.setBrandColor} />
							</div>
						</div>
					</div>
				</ControllerContainer>
			</div>
		);
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(EmbedProperties);
